/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CittadinoServizioDTO { 
    id?: string;
    tipo_servizio?: CittadinoServizioDTOTipoServizioEnum;
    tipo_pratica_id?: string;
    tipo_pratica_codice?: string;
    comune_id?: string;
    comune_nome?: string;
    comune_slug?: string;
    data_inizio?: string;
    data_fine?: string;
    tariffe_visibili?: boolean;
}
export enum CittadinoServizioDTOTipoServizioEnum {
    MENSA = 'MENSA'
};



